import { CLOUD_LAYOUT, CLOUD_QUN_CONTROL, CLOUD_GROUP_CONTROL_DEVICES } from "@/utils/key.js"

function getUserStorageKey(key) {
	const info = JSON.parse(localStorage.getItem('info') || '{}')
	return `${key}_${info.customer_id || 'guest'}`
}

function getStoredGroupControlDevices() {
	return JSON.parse(localStorage.getItem(getUserStorageKey(CLOUD_GROUP_CONTROL_DEVICES)) || '{"masterCode":"","controlledCodes":""}')
}

export default {
	state: {
		cloudDeviceArrangement: localStorage.getItem(CLOUD_LAYOUT) ? localStorage.getItem(CLOUD_LAYOUT) : 'TwoChannel',
		isQunControl: localStorage.getItem(getUserStorageKey(CLOUD_QUN_CONTROL)) === 'true',
		groupControlDevices: getStoredGroupControlDevices(),
	},
	mutations: {
		loadUserScopedState(state) {
			state.isQunControl = localStorage.getItem(getUserStorageKey(CLOUD_QUN_CONTROL)) === 'true'
			state.groupControlDevices = getStoredGroupControlDevices()
		},
		changeDeviceArrangementState(state, arrangement) {
			state.cloudDeviceArrangement = arrangement
			console.log(state.cloudDeviceArrangement, 'aggreement');
			localStorage.setItem(CLOUD_LAYOUT, arrangement);
		},
		setQunControlState(state, enabled) {
			state.isQunControl = Boolean(enabled)
			localStorage.setItem(getUserStorageKey(CLOUD_QUN_CONTROL), state.isQunControl)
		},
		setGroupControlDevices(state, devices) {
			state.groupControlDevices = devices
			localStorage.setItem(getUserStorageKey(CLOUD_GROUP_CONTROL_DEVICES), JSON.stringify(devices))
		},
	},

	actions: {
		async changeDeviceArrangement({ commit }, arrangement) {
			commit('changeDeviceArrangementState', arrangement);
		},
		changeQunControl({ commit }, enabled) {
			commit('setQunControlState', enabled)
		},
		setGroupControlDevices({ commit }, devices) {
			commit('setGroupControlDevices', devices)
		},
		loadUserScopedState({ commit }) {
			commit('loadUserScopedState')
		}
	},
}
